import {API_ACTION, API_GENERAL_QUESTION_DESCRIPTION} from '../../const/Api';
import {callAPI} from './callApi';
import {RestApiMethod} from '../../const/dataEnum';

const getDescriptionContent = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_GENERAL_QUESTION_DESCRIPTION + `/questions`,
    });
    return res.data;
  } catch (error) {
    console.error('getDescriptionContent Error:', error.message);
    return null;
  }
};

const getDescContentByDepartementId = async (departmentId, periodId) => {
  try {
    if (!departmentId || !periodId) {
      console.error('Department ID or Period ID is missing');
      return null;
    }
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_GENERAL_QUESTION_DESCRIPTION + `/questions/department/${departmentId}?periodId=${periodId}`,
    });
    return res.data;
  } catch (error) {
    console.error('getDescContentByDepartementId Error:', error.message);
    return null;
  }
};

const createDescriptionContent = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_GENERAL_QUESTION_DESCRIPTION + API_ACTION.CREATE,
      data,
    });
    return res.data;
  } catch (error) {
    console.error('createDescriptionContent Error:', error.message);
    return null;
  }
};

const updateDescriptionContent = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_GENERAL_QUESTION_DESCRIPTION + API_ACTION.UPDATE,
      data,
    });
    return res.data;
  } catch (error) {
    console.error('updateDescriptionContent Error:', error.message);
    return null;
  }
};

const GeneralDescriptionContent = {
  getDescriptionContent,
  getDescContentByDepartementId,
  createDescriptionContent,
  updateDescriptionContent,
};

export default GeneralDescriptionContent;
